export default "__VITE_ASSET__CEI4Vkul__"